// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-actions[data-v-52ce0a6b]{align-items:center;display:flex;gap:10px}", "",{"version":3,"sources":["webpack://./resources/js/Components/App/Header.vue"],"names":[],"mappings":"AACA,iCAEI,kBAAA,CADA,YAAA,CAEA,QAAA","sourcesContent":["\n.header-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
